import { fg } from '@atlassian/jira-feature-gating';
import { FIELD_TYPES } from './fieldTypes.tsx';
import type { FieldType } from './FieldType.types.tsx';

export const isDeliveryFieldType = (fieldType?: FieldType): boolean =>
	fieldType === FIELD_TYPES.DELIVERY_PROGRESS || fieldType === FIELD_TYPES.DELIVERY_STATUS;

const JPD_SYSTEM_FIELDS: Set<FieldType> = new Set([
	FIELD_TYPES.ASSIGNEE,
	FIELD_TYPES.CREATOR,
	FIELD_TYPES.CREATED,
	FIELD_TYPES.DESCRIPTION,
	FIELD_TYPES.ISSUE_ID,
	FIELD_TYPES.ISSUE_KEY,
	FIELD_TYPES.ISSUE_TYPE,
	FIELD_TYPES.LABELS,
	FIELD_TYPES.UPDATED,
	FIELD_TYPES.PROJECT,
	FIELD_TYPES.REPORTER,
	FIELD_TYPES.STATUS,
	FIELD_TYPES.SUMMARY,
	FIELD_TYPES.PLATFORM_GOALS,
	FIELD_TYPES.PLATFORM_FOCUS_AREAS,
	FIELD_TYPES.PLATFORM_ATLAS_PROJECT,

	FIELD_TYPES.ARCHIVED,
	FIELD_TYPES.ARCHIVED_BY,
	FIELD_TYPES.ARCHIVED_ON,
	FIELD_TYPES.ATLAS_GOAL,
	FIELD_TYPES.ATLAS_PROJECT,
	FIELD_TYPES.ATLAS_PROJECT_STATUS,
	FIELD_TYPES.DELIVERY_PROGRESS,
	FIELD_TYPES.DELIVERY_STATUS,
	FIELD_TYPES.INSIGHTS,
	FIELD_TYPES.ISSUE_COMMENTS,
	FIELD_TYPES.LINKED_ISSUES,
]);

export const isSystemFieldType = (fieldType?: FieldType): boolean => {
	if (!fieldType) {
		return false;
	}
	if (fieldType === FIELD_TYPES.PLATFORM_FOCUS_AREAS && !fg('jpd_focus_areas_field_support')) {
		return false;
	}

	return JPD_SYSTEM_FIELDS.has(fieldType);
};
